import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PhoneInput from 'react-phone-number-input/input'
import Select from "react-select";
import ClientRequest from "../services/ClientRequest";
import { decode } from "html-entities";
import { useSearchParams } from "react-router-dom";
import Summary from "./Summary";
import CountiesJson from "./counties.json"
import DisplayCurrency from "../services/DisplayCurrency";

const ClientForm = () => {
  //URL Params
  const [searchParams, setSearchParams] = useSearchParams();
  const existingPlan = searchParams.get("plan");

  //Request Client and recurly
  const request = new ClientRequest();

  //Form Reference
  const formRef = useRef();

  //Form submission
  const {register, setError, clearErrors, reset, handleSubmit, setValue, formState: { errors } } = useForm();

  //states
  const [plans, setPlans] = useState([]);
  const [planSelected, setPlanSelected] = useState({});
  const [showPlans, setShowPlans] = useState(true);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState();
  const [success, setSuccess] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);

  const onSubmit = (data) => {
    setLoadingRequest(true);
    setSuccess(false);

    request.create("processRequest", data)
      .then((res) => {
        const {success} = res;
        if (success) {
          //Clear form and show message
          setSuccess(true);
          setValue("plan", "");
          setLoadingRequest(false);

          searchParams.delete("plan");
          setSearchParams(searchParams);
          reset();
        }else{
          //An error occurred with messages from api
          const {data, error} = res;
          const errors = [];

          //errors on request to recurly
          if(error?.includes("Account number is invalid")) {
            //attaches error to data
            errors["account_number"] = ["Account number is invalid"];
          }

          if(error?.includes("Sort code is invalid")) {
            //attaches error to data
            errors["sort_code"] = ["Sort code is invalid"];
          }

          //All errors
          const allErrors = {...errors, ...data};

          //error on form
          if(allErrors){
            Object.entries(allErrors).map(err => {
              setError(err[0], {type: "focus", message: err[1]}, {shouldFocus: true})
              return err;
            });
          }

          setLoadingRequest(false);
        }
      })
      .catch((err) => {
        //An unexpected error occurred
        setLoadingRequest(false);
        console.log("Error", err);
      });
  };

  const createPlanObject = (plan) => {
    const name = decode(plan.name);

    return {
      ...plan,
      label: `${name} - ${DisplayCurrency(plan.currency)}${plan.price}`,
      name: name,
      value: plan.code
    };
  }

  useEffect(() => {
    request.read("plans")
      .then((res) => {
        const {data, success} = res;
        if (success) {
          setShowPlans(true);
          const plans = data.map(item => {
            return createPlanObject(item);
          });
          setPlans(plans);
          setLoadingPlans(false);

          if (existingPlan) {
            const item = data.filter(el => el.code === existingPlan);
            if (item.length > 0) {
              const itemSelected = createPlanObject(item[0]);
              setPlanSelected(itemSelected);
              setShowPlans(false);
            }
          }
        }
      })
      .catch(err => console.log("Error fetching plans ", err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectPlan = (code) => {
    const plan = plans.filter(el => el.value === code);
    if(plan.length > 0 ){
      const item = createPlanObject(plan[0]);
      setPlanSelected(item);
      setValue("plan", code);
    }
  }

  return (
    <div className="container">
      <form onSubmit={(e) => {
        clearErrors("plan");
        handleSubmit(onSubmit)(e).catch(() => {
          console.log("error form");
        })
      }} ref={formRef}>

        <div  className="rjs-main">
          <div  className="rjs-fieldset">
            <h3>
              Customer Information
            </h3>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("first_name")}
                  />
                  {errors.first_name && <span className="text-danger">{errors.first_name.message}</span>}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("last_name")}
                  />
                  {errors.last_name && <span className="text-danger">{errors.last_name.message}</span>}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Phone</Form.Label>
                  <PhoneInput
                    value={phoneNumber}
                    autoComplete="off"
                    onChange={(value) => setPhoneNumber(value)}
                    className="form-control"
                  />
                  {errors.phone && <span className="text-danger">{errors.phone.message}</span>}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    {...register("email")}
                  />
                  {errors.email && <span className="text-danger">{errors.email.message}</span>}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>1st Address</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("address1")}
                  />
                  {errors.address1 && <span className="text-danger">{errors.address1.message}</span>}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>2nd Address</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("address2")}
                  />
                  {errors.address2 && <span className="text-danger">{errors.address2.message}</span>}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("city")}
                  />
                  {errors.city && <span className="text-danger">{errors.city.message}</span>}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Postal Code</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("postal_code")}
                  />
                  {errors.postal_code && <span className="text-danger">{errors.postal_code.message}</span>}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>County</Form.Label>
                  <Select
                    options={CountiesJson}
                    onChange={(option) => setValue("state", option.value)}
                    placeholder="Select an county"
                    isLoading={loadingPlans}
                  />
                  {errors.state && <span className="text-danger">{errors.state.message}</span>}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    value="United Kingdom"
                    readOnly={true}
                    {...register("country")}
                  />
                  {errors.country && <span className="text-danger">{errors.country.message}</span>}
                </Form.Group>
              </Col>
            </Row>
          </div>
          <div  className="rjs-fieldset">
            <h3>
              Payment Information
            </h3>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Name On Account</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="BACS account name"
                    {...register("name_on_account")}
                  />
                  {errors.name_on_account && <span className="text-danger">{errors.name_on_account.message}</span>}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Bank account Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="11223311"
                    {...register("account_number")}
                  />
                  {errors.account_number && <span className="text-danger">{errors.account_number.message}</span>}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Branch Sort Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="200000"
                    {...register("sort_code")}
                  />
                  {errors.sort_code && <span className="text-danger">{errors.sort_code.message}</span>}
                </Form.Group>
              </Col>
            </Row>
          </div>
        </div>
        <div  className="rjs-sidebar">
          <div  className="rjs-fieldset">
            <h3>
              Purchase information
            </h3>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Plans</Form.Label>
                  <Form.Control
                    type="hidden"
                    value={existingPlan || ''}
                    {...register("plan")}
                  />
                  {!showPlans ? (
                    <React.Fragment>
                      <Form.Control
                        readOnly={true}
                        type="text"
                        value={`${planSelected.label} - ${DisplayCurrency(planSelected.currency)}${planSelected.price}`}
                      />
                    </React.Fragment>
                  ) : (
                    <Select
                      options={plans}
                      onChange={(option) => selectPlan(option.value)}
                      placeholder="Select a plan"
                      isLoading={loadingPlans}
                    />
                  )}

                  {errors.plan && <span className="text-danger">{errors.plan.message}</span>}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasic">
                  <Form.Label>Sales Rep Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="John Doe"
                    {...register("repName")}
                  />
                  {errors.repName && <span className="text-danger">{errors.repName.message}</span>}
                </Form.Group>
              </Col>
            </Row>
          </div>
          <div  className="rjs-fieldset">
            <Summary item={planSelected}/>
          </div>
          <div className="d-grid gap-2 mb-2">
            <Button size="lg" variant="primary" type="submit" disabled={loadingRequest}>
              {loadingRequest ? 'Loading…' : 'Complete Payment'}
            </Button>
          </div>
          {success && (
            <Alert variant="success">
              Request has been sent successfully
            </Alert>
          )}
        </div>
      </form>
    </div>
  );
};

export default ClientForm;
